import { defineStore } from 'pinia'

export const useApp = defineStore('app', {
    state: () => ({
        token: null,
        tenantId: null
    }),
    getters: {},
    actions: {
        setToken(token) {
            this.token = token
        },
        setTenantId(tenantId) {
            this.tenantId = tenantId
        }
    }
})
